import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@capturum/auth';
import { LoginService } from '../login.service';
import { LoginAction } from '../base/login-action.enum';

@Component({
  selector: 'cap-forgot-password',
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {
  public form: FormGroup;

  public emailError: boolean;
  public resetError: boolean;
  public resetSuccess: boolean;

  public loading = false;

  constructor(
    private authService: AuthService,
    private loginService: LoginService
  ) {
    this.emailError = false;
    this.resetError = false;
    this.resetSuccess = false;
  }

  public ngOnInit() {
    this.createForm();
  }

  /**
   * Submit request a new password form
   */
  public onSubmit(): void {
    if (this.loading) {
      return;
    }

    this.emailError = false;
    this.resetError = false;
    this.resetSuccess = false;

    if (this.form.valid) {
      this.loading = true;
      const { email } = this.form.value;
      this.authService.recoverPassword(email).subscribe(
        (response) => {
          this.loginService.setAction(LoginAction.forgot, true);
          this.loginService.onForgotSuccess(response);

          if (response) {
            this.resetError = false;
            this.resetSuccess = true;
          }
        },
        (error) => {
          this.loginService.setAction(LoginAction.forgot, false);
          this.loginService.onForgotFail(error);
          this.resetError = true;
          this.loading = false;
        }
      );
    } else {
      // Show login error message
      this.emailError = true;
    }
  }

  /**
   * Create fields for login form
   */
  private createForm(): void {
    this.form = this.loginService.forgotForm;
  }
}
